module.exports = __webpack_public_path__ + "static/img/follow-up-create.d6eecfe5.png";